import React, {useEffect, useRef, useState} from "react";
import PanelForm from "../../panel/Form";
import {Dropdown} from "primereact/dropdown";
import {AppApi} from "../../AppApi";
import {Calendar} from "primereact/calendar";
import {useNavigate} from "react-router-dom";
import Button from "../../common/botton/Button";
import {AutoComplete} from "primereact/autocomplete";

export default function SearchPanel(props) {

    const navigate = useNavigate();

    const [locationOptions, setLocationOptions] = useState(null);
    const [languageOptions, setLanguageOptions] = useState(null);
    const [appointmentLengths, setAppointmentLengths] = useState(null);
    const [filteredLocationOptions, setFilteredLocationOptions] = useState(null);
    const [stateOptions, setStateOptions] = useState();



    useEffect(() => {
        if(locationOptions == null) {
            AppApi.pub.getTripOptionLocations()
                .then(response => {
                    setLocationOptions(response.data)
                })
                .catch(console.log)
        }
    }, [locationOptions]);

    useEffect(() => {
        if(locationOptions == null) {
            AppApi.pub.getTripOptionLanguages()
                .then(response => {
                    let options = []
                    options.push({code: null, label: 'Alle'})
                    options.push(...response.data)
                    setLanguageOptions(options)
                })
                .catch(console.log)
        }
    }, [languageOptions]);

    useEffect(() => {
        if(locationOptions == null) {
            AppApi.pub.getTripOptionAppointmentLengths()
                .then(response => {
                    let options = []
                    options.push({code: null, label: 'Beliebig'})
                    options.push(...response.data)
                    setAppointmentLengths(options)
                })
                .catch(console.log)
        }
    }, [languageOptions]);


    useEffect(() => {
        console.log("searchSwitch:" + props.searchSwitch)
        console.log("isXL:" + props.isXL)
        if(props.searchSwitch === "searchPanel" && props.isXL === false) {
            props.setTrips && props.setTrips(null)
            props.setProgress && props.setProgress(false)
        } else if(props.isXL === undefined) {

        } else {
            getTrips()
        }
    }, [props.selectedFavorite, props.selectedState, props.selectedLanguage, props.selectedSuitableFor, props.selectedAppointmentLength, props.selectedAppointment, props.selectedAppointment]);



    useEffect(() => {
        if(stateOptions == null) {
            AppApi.pub.getTripOptionStates()
                .then(response => {
                    let options = []
                    options.push({code: null, label: 'Alle'})
                    options.push(...response.data)
                    setStateOptions(options)
                })
                .catch(console.log)
        }
    }, [stateOptions]);



    function getTrips() {
        props.setProgress && props.setProgress(true)
        AppApi.pub.getTrips({favorite: props.selectedFavorite, state: props.selectedState?.code, languageCode: props.selectedLanguage?.code, suitableFor: props.selectedSuitableFor, appointmentLength: props.selectedAppointmentLength?.code, location: props.selectedLocation, appointment: props.selectedAppointment, online: true})
            .then(response => {
                props.setTrips && props.setTrips(response.data)
                props.setProgress && props.setProgress(false)
            })
            .catch(console.log)
    }






    const search = (event) => {
        // Timeout to emulate a network connection
        setTimeout(() => {
            let _filteredCountries;

            if (!event.query.trim().length) {
                _filteredCountries = [...locationOptions];
            }
            else {
                _filteredCountries = locationOptions.filter((location) => {
                    if(location.toLowerCase().startsWith(event.query.toLowerCase())){
                        return true
                    }
                    if(location.toLowerCase().includes(event.query.toLowerCase())){
                        return true
                    }
                });
            }

            setFilteredLocationOptions(_filteredCountries);
        }, 250);
    }

    return (
        <div style={{textAlign: 'left'}}>
            <PanelForm style={{background: 'rgba(255,255,255)'}}>
                <div className="flex flex-column xl:flex-row" style={{margin: '0px 30px', paddingBottom: '10px'}}>
                    <div className="flex-2" style={{padding: '4px'}}>
                        <div>
                            <div style={{fontSize: '12px', fontWeight: 'bold'}}>Anerkannt für:</div>
                            <Dropdown
                                appendTo="self"
                                placeholder="Alle"
                                style={{width: '100%', borderRadius: '8px'}}
                                className="p-inputtext-sm"
                                value={props.selectedState}
                                onChange={(e) => props.setSelectedState(e.value)}
                                options={stateOptions}
                                optionLabel="label"/>
                        </div>
                    </div>
                    <div className="flex-2" style={{padding: '4px'}}>
                        <div>
                            <div style={{fontSize: '12px', fontWeight: 'bold'}}>Sprache:</div>
                            <Dropdown
                                appendTo="self"
                                placeholder="Alle"
                                style={{width: '100%', borderRadius: '8px'}}
                                className="p-inputtext-sm"
                                value={props.selectedLanguage}
                                onChange={(e) => props.setSelectedLanguage(e.value)}
                                options={languageOptions}
                                optionLabel="label"/>
                        </div>
                    </div>
                    <div className="flex-2" style={{padding: '4px'}}>
                        <div>
                            <div style={{fontSize: '12px', fontWeight: 'bold'}}>Dauer:</div>
                            <Dropdown
                                appendTo="self"
                                placeholder="Alle"
                                style={{width: '100%', borderRadius: '8px'}}
                                className="p-inputtext-sm"
                                value={props.selectedAppointmentLength}
                                onChange={(e) => props.setSelectedAppointmentLength(e.value)}
                                options={appointmentLengths}
                                optionLabel="label"/>
                        </div>
                    </div>
                    <div className="flex-1" style={{padding: '4px'}}>
                        <div style={{fontSize: '12px', fontWeight: 'bold'}}>Wohin:</div>
                        <AutoComplete
                            appendTo="self"
                            inputStyle={{width: '100%', borderRadius: '8px'}}
                            style={{width: '100%'}}
                            className="p-inputtext-sm"
                            value={props.selectedLocation}
                            suggestions={filteredLocationOptions}
                            completeMethod={search}
                            onChange={(e) => props.setSelectedLocation(e.value)} />
                    </div>
                    <div className="flex-2" style={{padding: '4px'}}>
                        <div style={{fontSize: '12px', fontWeight: 'bold'}}>Startdatum:</div>
                        <Calendar
                            appendTo="self"
                            showButtonBar
                            dateFormat="dd.mm.yy"
                            style={{width: '100%'}}
                            inputStyle={{borderRadius: '8px'}}
                            className="p-inputtext-sm"
                            locale="de"
                            value={new Date(props.selectedAppointment)}
                            onChange={(e) => {

                                let date = e.value
                                if(date){
                                    date = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                    let localDate = date.toISOString().substring(0, 10)
                                    props.setSelectedAppointment(localDate)
                                } else {
                                    props.setSelectedAppointment(undefined)
                                }
                            }}
                            readOnlyInput
                            hideOnRangeSelection/>
                    </div>

                    <div style={{marginTop: '12px', padding: '4px', width: 50}}>
                        <Button style={{fontSize: '9px', fontWeight: 'bold'}} icon={<i className="pi pi-search"/>} onClick={() => {
                            getTrips()
                            if(window.location.pathname !== "/") {
                                navigate("/")
                            }
                            props.onSearch && props.onSearch();
                        }}/>
                    </div>
                </div>
            </PanelForm>

        </div>
    )
}